import styles from './CloseButton.scss';

import cx from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { MaterialIcon } from 'src/components/MaterialIcon/MaterialIcon';

type Props = React.ButtonHTMLAttributes<HTMLButtonElement>;

const CloseButton: React.FC<Props> = ({
  title, className, ...props
}) => {
  const [t] = useTranslation();
  return (
    <button className={cx(styles.closeButton, className)} title={title || t('close')} {...props}>
      <MaterialIcon icon="close" />
    </button>
  );
};

export { CloseButton };
